import React from 'react';
import { Button, Radio, DatePicker } from '@maxtropy/components';
import { Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import type { DashboardDimension } from '../../types';
import { DIMENSION_OPTIONS } from '../../constants';
import SubTitle from '@/components/SubTitle';
import EmissionOverview from '../EmissionOverview';

interface DimensionSelectorProps {
  dimension: DashboardDimension;
  timeValue: string;
  refreshKey: number;
  onDimensionChange: (dimension: DashboardDimension) => void;
  onTimeChange: (time: string) => void;
  onOpenRecalculate: () => void;
}

const DimensionSelector: React.FC<DimensionSelectorProps> = ({
  dimension,
  timeValue,
  refreshKey,
  onDimensionChange,
  onTimeChange,
  onOpenRecalculate,
}) => {
  const navigate = useNavigate();

  const handleDimensionChange = (e: any) => {
    const newDimension = e.target.value as DashboardDimension;
    onDimensionChange(newDimension);
    // 切换维度时重置时间值为默认值
    const defaultTime = newDimension === 'MONTH' ? dayjs().format('YYYY-MM') : dayjs().format('YYYY');
    onTimeChange(defaultTime);
  };

  const handleTimeChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      const format = dimension === 'MONTH' ? 'YYYY-MM' : 'YYYY';
      onTimeChange(date.format(format));
    }
  };

  const handleConfigClick = () => {
    navigate('/env/monitor/kanban/config');
  };

  return (
    <SubTitle
      title={
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 26 }}>
          <span>数据总览</span>
          <Space size={8}>
            <Radio.Group optionType="button" buttonStyle="solid" value={dimension} onChange={handleDimensionChange}>
              {DIMENSION_OPTIONS.map(opt => (
                <Radio.Button key={opt.value} value={opt.value}>
                  {opt.label}
                </Radio.Button>
              ))}
            </Radio.Group>

            <DatePicker
              picker={dimension === 'MONTH' ? 'month' : 'year'}
              value={dayjs(timeValue)}
              onChange={handleTimeChange}
              allowClear={false}
              placeholder={dimension === 'MONTH' ? '选择月份' : '选择年份'}
            />
          </Space>
        </div>
      }
      extraContent={
        <Space size={8}>
          <Button type="primary" onClick={handleConfigClick}>
            配置
          </Button>
          <Button type="primary" onClick={onOpenRecalculate}>
            重计算
          </Button>
        </Space>
      }
      style={{ padding: 0 }}
    >
      {/* 排放总览 */}
      <EmissionOverview dimension={dimension} timeValue={timeValue} refreshKey={refreshKey} />
    </SubTitle>
  );
};

export default DimensionSelector;
